import React, { useState } from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import { FaPlus } from 'react-icons/fa';
import './AdvancedFilters.css';
import { useGoogleTranslate } from '../../Hooks/useGoogleTranslate';

// Import filter modals
import EducationLevelModal from './Modals/EducationLevelModal';
import OccupationModal from './Modals/OccupationModal';
import ReligionModal from './Modals/ReligionModal';
import EthnicityModal from './Modals/EthnicityModal';
import PoliticalViewsModal from './Modals/PoliticalViewsModal';
import RelationshipStatusModal from './Modals/RelationshipStatusModal';
import BodyTypeModal from './Modals/BodyTypeModal';
import DrinkingModal from './Modals/DrinkingModal';
import SmokingCigarettesModal from './Modals/SmokingCigarettesModal';
import SmokingWeedModal from './Modals/SmokingWeedModal';
import ExerciseModal from './Modals/ExerciseModal';
import PetsModal from './Modals/PetsModal';
import HobbiesModal from './Modals/HobbiesModal';
import LanguagesModal from './Modals/LanguagesModal';

const AdvancedFilters = ({ onApply, onClear, initialFilters = {} }) => {
  const clearLabel = useGoogleTranslate('Clear');
  const applyLabel = useGoogleTranslate('Apply');
  const addToFilterLabel = useGoogleTranslate('Add this to filter');
  const selectedSuffix = useGoogleTranslate('selected');
  const hobbiesQuestion = useGoogleTranslate('Their Hobbies and Interests?');
  const smokeCigarettesQuestion = useGoogleTranslate('Do they smoke cigarettes?');
  const exerciseQuestion = useGoogleTranslate('Do they exercise?');
  const bodyTypeQuestion = useGoogleTranslate("What's their body type?");
  const educationQuestion = useGoogleTranslate("What's their highest education level?");
  const religionQuestion = useGoogleTranslate("What's their religion?");
  const politicalViewsQuestion = useGoogleTranslate('What are their political views?');
  const occupationQuestion = useGoogleTranslate("What's their occupation?");
  const drinkQuestion = useGoogleTranslate('Do they drink?');
  const smokeWeedQuestion = useGoogleTranslate('Do they smoke weed?');
  const petsQuestion = useGoogleTranslate('Do they have any pets?');
  const languageSpeakQuestion = useGoogleTranslate('What language do they speak?');
  const loveLanguageQuestion = useGoogleTranslate("What's their love language?");
  const ethnicityQuestion = useGoogleTranslate("What's their ethnicity?");
  const idealMatchHeading = useGoogleTranslate('What is your ideal match?');
  const doneLabel = useGoogleTranslate('Done');

    const [filters, setFilters] = useState({
    education_level: initialFilters.education_level || [],
    occupation: initialFilters.occupation || [],
    religion: initialFilters.religion || [],
    ethnicity: initialFilters.ethnicity || [],
    political_views: initialFilters.political_views || [],
    relationship_status: initialFilters.relationship_status || [],
    body_type: initialFilters.body_type || [],
    do_you_drink: initialFilters.do_you_drink || [],
    do_you_smoke_cigarettes: initialFilters.do_you_smoke_cigarettes || [],
    do_you_smoke_week: initialFilters.do_you_smoke_week || [],
    do_you_excercise: initialFilters.do_you_excercise || [],
    do_you_have_any_pets: initialFilters.do_you_have_any_pets || [],
    languages_spoken: initialFilters.languages_spoken || [],
    outdoor_and_sports_hobbies: initialFilters.outdoor_and_sports_hobbies || [],
    artistic_and_creative_hobbies: initialFilters.artistic_and_creative_hobbies || [],
    intellectual_and_educational_hobbies: initialFilters.intellectual_and_educational_hobbies || [],
    culinary_and_lifestyle_hobbies: initialFilters.culinary_and_lifestyle_hobbies || [],
    fitness_and_wellness_hobbies: initialFilters.fitness_and_wellness_hobbies || [],
    adventure_and_exploration_hobbies: initialFilters.adventure_and_exploration_hobbies || [],
    technology_and_gaming_hobbies: initialFilters.technology_and_gaming_hobbies || [],
    social_and_community_hobbies: initialFilters.social_and_community_hobbies || [],
    ...initialFilters
  });

  const [activeModal, setActiveModal] = useState(null);

  const filterCategories = [
    {
      key: 'outdoor_and_sports_hobbies',
      label: hobbiesQuestion,
      type: 'hobbies',
      modal: 'hobbies'
    },
    {
      key: 'do_you_smoke_cigarettes',
      label: smokeCigarettesQuestion,
      type: 'multiple',
      modal: 'smoking-cigarettes'
    },
    {
      key: 'do_you_excercise',
      label: exerciseQuestion,
      type: 'multiple',
      modal: 'exercise'
    },
    {
      key: 'body_type',
      label: bodyTypeQuestion,
      type: 'multiple',
      modal: 'body-type'
    },
    {
      key: 'education_level',
      label: educationQuestion,
      type: 'multiple',
      modal: 'education'
    },
    {
      key: 'religion',
      label: religionQuestion,
      type: 'multiple',
      modal: 'religion'
    },
    {
      key: 'political_views',
      label: politicalViewsQuestion,
      type: 'multiple',
      modal: 'political-views'
    },
    {
      key: 'occupation',
      label: occupationQuestion,
      type: 'multiple',
      modal: 'occupation'
    },
    {
      key: 'do_you_drink',
      label: drinkQuestion,
      type: 'multiple',
      modal: 'drinking'
    },
    {
      key: 'do_you_smoke_week',
      label: smokeWeedQuestion,
      type: 'multiple',
      modal: 'smoking-weed'
    },
    {
      key: 'do_you_have_any_pets',
      label: petsQuestion,
      type: 'multiple',
      modal: 'pets'
    },
    {
      key: 'languages_spoken',
      label: languageSpeakQuestion,
      type: 'multiple',
      modal: 'languages'
    },
    {
      key: 'relationship_status',
      label: loveLanguageQuestion,
      type: 'multiple',
      modal: 'relationship-status'
    },
    {
      key: 'ethnicity',
      label: ethnicityQuestion,
      type: 'multiple',
      modal: 'ethnicity'
    }
  ];

  const handleFilterClick = (modalKey) => {
    setActiveModal(modalKey);
  };

  const handleModalClose = () => {
    setActiveModal(null);
  };

  const handleFilterUpdate = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  };

  const handleApply = () => {
    onApply(filters);
  };

  const handleClear = () => {
    const defaultFilters = {
      education_level: [],
      occupation: [],
      religion: [],
      ethnicity: [],
      political_views: [],
      relationship_status: [],
      body_type: [],
      do_you_drink: [],
      do_you_smoke_cigarettes: [],
      do_you_smoke_week: [],
      do_you_excercise: [],
      do_you_have_any_pets: [],
      languages_spoken: [],
      outdoor_and_sports_hobbies: [],
      artistic_and_creative_hobbies: [],
      intellectual_and_educational_hobbies: [],
      culinary_and_lifestyle_hobbies: [],
      fitness_and_wellness_hobbies: [],
      adventure_and_exploration_hobbies: [],
      technology_and_gaming_hobbies: [],
      social_and_community_hobbies: []
    };
    setFilters(defaultFilters);
    onClear(defaultFilters);
  };

  const getFilterDisplayValue = (category) => {
    const value = filters[category.key];
    if (Array.isArray(value)) {
      return value.length > 0
        ? `${value.length} ${selectedSuffix}`
        : addToFilterLabel;
    }
    return value || addToFilterLabel;
  };

  const renderModal = () => {
    switch (activeModal) {
      case 'education':
        return (
          <EducationLevelModal
            show={true}
            onHide={handleModalClose}
            value={filters.education_level}
            onUpdate={(value) => handleFilterUpdate('education_level', value)}
          />
        );
      case 'occupation':
        return (
          <OccupationModal
            show={true}
            onHide={handleModalClose}
            value={filters.occupation}
            onUpdate={(value) => handleFilterUpdate('occupation', value)}
            forSearchFilter
          />
        );
      case 'religion':
        return (
          <ReligionModal
            show={true}
            onHide={handleModalClose}
            value={filters.religion}
            onUpdate={(value) => handleFilterUpdate('religion', value)}
          />
        );
      case 'ethnicity':
        return (
          <EthnicityModal
            show={true}
            onHide={handleModalClose}
            value={filters.ethnicity}
            onUpdate={(value) => handleFilterUpdate('ethnicity', value)}
          />
        );
      case 'political-views':
        return (
          <PoliticalViewsModal
            show={true}
            onHide={handleModalClose}
            value={filters.political_views}
            onUpdate={(value) => handleFilterUpdate('political_views', value)}
          />
        );
      case 'relationship-status':
        return (
          <RelationshipStatusModal
            show={true}
            onHide={handleModalClose}
            value={filters.relationship_status}
            onUpdate={(value) => handleFilterUpdate('relationship_status', value)}
          />
        );
      case 'body-type':
        return (
          <BodyTypeModal
            show={true}
            onHide={handleModalClose}
            value={filters.body_type}
            onUpdate={(value) => handleFilterUpdate('body_type', value)}
          />
        );
      case 'drinking':
        return (
          <DrinkingModal
            show={true}
            onHide={handleModalClose}
            value={filters.do_you_drink}
            onUpdate={(value) => handleFilterUpdate('do_you_drink', value)}
          />
        );
      case 'smoking-cigarettes':
        return (
          <SmokingCigarettesModal
            show={true}
            onHide={handleModalClose}
            value={filters.do_you_smoke_cigarettes}
            onUpdate={(value) => handleFilterUpdate('do_you_smoke_cigarettes', value)}
          />
        );
      case 'smoking-weed':
        return (
          <SmokingWeedModal
            show={true}
            onHide={handleModalClose}
            value={filters.do_you_smoke_week}
            onUpdate={(value) => handleFilterUpdate('do_you_smoke_week', value)}
          />
        );
      case 'exercise':
        return (
          <ExerciseModal
            show={true}
            onHide={handleModalClose}
            value={filters.do_you_excercise}
            onUpdate={(value) => handleFilterUpdate('do_you_excercise', value)}
          />
        );
      case 'pets':
        return (
          <PetsModal
            show={true}
            onHide={handleModalClose}
            value={filters.do_you_have_any_pets}
            onUpdate={(value) => handleFilterUpdate('do_you_have_any_pets', value)}
          />
        );
      case 'hobbies':
        return (
          <HobbiesModal
            show={true}
            onHide={handleModalClose}
            values={filters}
            onUpdate={handleFilterUpdate}
          />
        );
      case 'languages':
        return (
          <LanguagesModal
            show={true}
            onHide={handleModalClose}
            value={filters.languages_spoken}
            onUpdate={(value) => handleFilterUpdate('languages_spoken', value)}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="">

      {/* Ideal Match Heading */}
      <div className="ideal-match-heading text-center mb-4">
        <h4 className="text-dark fw-bold">{idealMatchHeading}</h4>
      </div>

      {/* Filter Categories Grid */}
      <div className="advanced-filters-grid">
        <Row>
          {filterCategories.map((category, index) => (
            <Col md={6} key={category.key} className="mb-3">
              <div className="filter-category">
                <h6 className="filter-category-label">{category.label}</h6>
                <div
                  className="filter-input rounded-pill"
                  onClick={() => handleFilterClick(category.modal)}
                >
                  <FaPlus className="filter-plus-icon" />
                  <span className="filter-input-text">
                    {getFilterDisplayValue(category)}
                  </span>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>

      {/* Action Buttons */}
      <div className="filter-actions">
        <Button
          variant="outline-primary"
          className="clear-btn"
          onClick={handleClear}
        >
          {clearLabel}
        </Button>
        <Button
          variant="primary"
          className="apply-btn"
          onClick={handleApply}
        >
          {applyLabel}
        </Button>
      </div>

      {/* Render Active Modal */}
      {renderModal()}
    </div>
  );
};

export default AdvancedFilters;
